module.exports = __webpack_public_path__ + "static/media/techGrid-01.83e2100b.jpg";